import {
  XiaoLiuRen,
  BMIIndex,
  UserNote,
  PuzzleGame,
  LunarDate,
  FlipCard,
  TicTacToe,  
  PetGame,
  AIChat,
  LocalWeather,
  UnsplashSearch,
  QRCode,
  PhoneNumber,
  ConstellationFortune,
  RandomJokes,
  HotList,
  AIDraw
} from "../components";

const components = [
  XiaoLiuRen,
  BMIIndex,
  UserNote,
  PuzzleGame,
  LunarDate,
  FlipCard,
  TicTacToe,
  PetGame,
  AIChat,
  LocalWeather,
  UnsplashSearch,
  QRCode,
  PhoneNumber,
  ConstellationFortune,
  RandomJokes,
  HotList,
  AIDraw
];

const buttons = [
  { text: "小六壬", component: XiaoLiuRen },
  { text: "笔记本", component: UserNote },
  { text: "拼图游戏", component: PuzzleGame },
  { text: "BMI计算", component: BMIIndex },
  { text: "农历日期", component: LunarDate },
  { text: "记忆翻牌", component: FlipCard },
  { text: "井字棋", component: TicTacToe },
  { text: "宠物游戏", component: PetGame },
  { text: "AI猫娘", component: AIChat },
  { text: "本地天气", component: LocalWeather },
  { text: "网络搜图", component: UnsplashSearch },
  { text: "二维码生成", component: QRCode },
  { text: "手机号查询", component: PhoneNumber },
  { text: "星座运势", component: ConstellationFortune },
  { text: "随机笑话", component: RandomJokes },
  { text: "热搜榜单", component: HotList },
  { text: "AI绘画", component: AIDraw }
];

export { components, buttons };
